<template>
  <!-- 分类筛选区域 -->
  <div class="tree-content">
    <div class="tree-content-label" @click.stop @mouseenter="showTree = true">
      <div
        class="label-item"
        v-for="(item, index) in categoryTreeInfo"
        :key="index"
      >
        <div class="label-name">
          <Tooltips :innerContent="item.levelTitle" />
        </div>
        <span style="margin-right: 8px">:</span>
        <div class="label-name">
          <Tooltips :innerContent="item.categoryName" />
        </div>
      </div>
    </div>
    <div
      class="meter-cascader"
      @mouseleave="showTree = false"
      @click.stop
      v-show="showTree"
    >
      <!-- 分类组件 -->
      <div class="cascader-menu-wrap">
        <!-- 一级 -->
        <div class="cascader-menu">
          <div class="cascader-title">
            {{ categoryTitles[0] }} <i class="el-icon-arrow-right"></i>
          </div>
          <div class="cascader-menu__list">
            <div
              class="cascader-node"
              v-for="(item, index) in categoryTree"
              :key="index"
              :class="{
                'in-active-path': choosedCategoryIds.includes(item.categoryId),
              }"
              @mouseenter="firstHover(item)"
            >
              <Tooltips :innerContent="item.categoryName" />
            </div>
            <div class="cascader-node" v-if="categoryTree.length === 0">
              暂无分类
            </div>
          </div>
        </div>
        <!-- 二级 -->
        <div class="cascader-menu" v-if="categorySecondTree.length > 0">
          <div class="cascader-title">
            {{ categoryTitles[1] }} <i class="el-icon-arrow-right"></i>
          </div>
          <div class="cascader-menu__list">
            <div
              class="cascader-node"
              v-for="(item, index) in categorySecondTree"
              :key="index"
              :class="{
                'in-active-path': choosedCategoryIds.includes(item.categoryId),
              }"
              @mouseenter="secondHover(item)"
            >
              <Tooltips :innerContent="item.categoryName" />
            </div>
          </div>
        </div>
        <!-- 三级 -->
        <div class="cascader-menu" v-if="categoryThirdTree.length > 0">
          <div class="cascader-title">
            {{ categoryTitles[2] }}
          </div>
          <div class="cascader-menu__list">
            <div
              class="cascader-node"
              v-for="(item, index) in categoryThirdTree"
              :key="index"
              :class="{
                'in-active-path': choosedCategoryIds.includes(item.categoryId),
              }"
              @mouseenter="thirdHover(item)"
              @click="thirdClick(item)"
            >
              <Tooltips :innerContent="item.categoryName" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltips from '@/components/tooltipShow'

export default {
  components: {
    Tooltips
  },
  props: {},
  data () {
    return {
      showTree: false,
      categoryTree: [], // 类目树
      categorySecondTree: [], // 二级类目
      categoryThirdTree: [], // 三级类目
      choosedCategoryIds: [], // 已选中类目id,用与回显
      categoryTreeInfo: [] // 已选中类目层级标题和类目名称id返回
    }
  },
  mounted () {
    this.getTree()
  },
  computed: {
    // 获取类目标题
    categoryTitles () {
      const firstCategory = this.categoryTree.find(
        (item) => item.categoryId === this.choosedCategoryIds[0]
      )
      const secondCategory = this.categorySecondTree.find(
        (item) => item.categoryId === this.choosedCategoryIds[1]
      )
      const thirdCategory = this.categoryThirdTree.find(
        (item) => item.categoryId === this.choosedCategoryIds[2]
      )
      return [
        (firstCategory && firstCategory.levelTitle) || '',
        (secondCategory && secondCategory.levelTitle) || '',
        (thirdCategory && thirdCategory.levelTitle) || '-'
      ]
    }
  },
  methods: {
    hideTree () {
      this.showTree = false
    },
    // 获取类目树
    getTree () {
      this.$http
        .get('/front/cross/commodity-user/design/category/tree')
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.categoryTree = res.data || []
            // 设置默认3级类目
            this.getCategoryTreeInfoByThirdCategoryId(
              this.$route.query.thirdCategoryId
            )
          }
        })
    },
    // 通过三级类目获取父爷及更往上层级信息
    getCategoryTreeInfoByThirdCategoryId (thirdCategoryId) {
      // 找到3级类目各种信息
      const result = this.findCategoryPath(this.categoryTree, thirdCategoryId)
      if (!result) return
      this.categoryTreeInfo = result

      // 赋值选中三级类目
      this.choosedCategoryIds = result.map((item) => item.categoryId)

      // 赋值二级类目回显,从一级类目树取children
      const firstChooseChildren = this.categoryTree.find(
        (item) => item.categoryId === this.choosedCategoryIds[0]
      )
      this.categorySecondTree =
        (firstChooseChildren && firstChooseChildren.children) || []

      // 赋值三级类目回显,从二级类目回显里取children
      const secondChooseChildren = this.categorySecondTree.find(
        (item) => item.categoryId === this.choosedCategoryIds[1]
      )
      this.categoryThirdTree =
        (secondChooseChildren && secondChooseChildren.children) || []

      // 获取三级类目操作示意图
      const categoryThirdImg =
        this.categoryTreeInfo &&
        this.categoryTreeInfo[2] &&
        this.categoryTreeInfo[2].diagramImgs
      this.$emit('getImg', (categoryThirdImg || []).join(','))
    },
    /**
     * 根据三级类目查找其父级及父父级层级信息
     * @param {Array} categoryTree - 类目树，结构为嵌套数组
     * @param {string} targetCategory - 目标三级类目
     * @param {Array} [path=[]] - 当前递归路径（内部使用）
     * @param {string} targetKey - 寻找的目标主键值
     * @param {Array} [targetKeys = ['categoryName', 'levelTitle']] - 寻找的目标附带信息
     * @returns {Array|null} - 返回包含父级及父父级信息的数组，若未找到则返回 null
     */
    findCategoryPath (
      categoryTree,
      targetCategory,
      path = [],
      targetKey = 'categoryId',
      targetKeys = ['categoryName', 'levelTitle', 'diagramImgs']
    ) {
      for (const category of categoryTree) {
        // 如果当前类目是目标类目，返回当前路径
        // eslint-disable-next-line eqeqeq
        if (category[targetKey] == targetCategory) {
          const targetObj = {
            [targetKey]: category[targetKey]
          }
          targetKeys.forEach((item) => {
            targetObj[item] = category[item]
          })
          return [...path, targetObj]
        }

        // 如果有子类目，递归查找
        if (category.children && category.children.length) {
          const targetObj = {
            [targetKey]: category[targetKey]
          }
          targetKeys.forEach((item) => {
            targetObj[item] = category[item]
          })
          const result = this.findCategoryPath(
            category.children,
            targetCategory,
            [...path, targetObj]
          )
          if (result) {
            return result
          }
        }
      }

      // 未找到目标类目，返回 null
      return null
    },
    // 一级类目hover事件
    firstHover (item) {
      if (
        this.choosedCategoryIds[0] === item.categoryId &&
        this.categorySecondTree.length
      ) {
        return
      }
      this.categorySecondTree = item.children || []
      this.categoryThirdTree = []
      // 默认选中二级类目第一条
      if (this.categorySecondTree.length) {
        this.choosedCategoryIds = [
          item.categoryId,
          this.categorySecondTree[0].categoryId
        ]
      } else {
        this.choosedCategoryIds = [item.categoryId]
      }
    },
    // 二级类目hover事件
    secondHover (item) {
      if (
        this.choosedCategoryIds[1] === item.categoryId &&
        this.categoryThirdTree.length
      ) {
        return
      }
      this.categoryThirdTree = item.children || []
      // 默认选中三级类目第一条
      if (this.categoryThirdTree.length) {
        this.choosedCategoryIds = [
          this.choosedCategoryIds[0],
          item.categoryId,
          this.categoryThirdTree[0].categoryId
        ]
      } else {
        this.choosedCategoryIds = [this.choosedCategoryIds[0], item.categoryId]
      }
    },
    // 三级类目hover事件
    thirdHover (item) {
      this.choosedCategoryIds = [
        this.choosedCategoryIds[0],
        this.choosedCategoryIds[1],
        item.categoryId
      ]
    },
    // 切换类目事件
    thirdClick (item) {
      if (item.categoryId === this.categoryTreeInfo[2].categoryId) return
      this.$confirm(
        '切换后已选择的配置内容将会被清除，请再次确认是否要切换。',
        '温馨提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'comfirm-box',
          type: 'warning'
        }
      ).then(() => {
        this.hideTree()
        this.$emit('getDetail', item.categoryId)
        this.getCategoryTreeInfoByThirdCategoryId(item.categoryId)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-content {
  position: relative;

  .tree-content-label {
    font-size: 14px;
    color: #666;
    font-weight: bold;
    display: flex;

    .label-item {
      display: flex;
      position: relative;
      align-items: center;
      cursor: pointer;

      &:last-child {
        &::after {
          display: none;
        }
      }

      &::after {
        content: "";
        background: #2a54d1;
        width: 1px;
        height: 12px;
        margin-left: 10px;
        margin-right: 10px;
      }

      .label-name {
        max-width: 129px;
      }
    }
  }

  .meter-cascader {
    position: absolute;
    z-index: 100;
    top: 33px;
    left: 0;
    background: rgba(255, 255, 255, 0.98);
    display: flex;
    border-radius: 4px;
    border: 1px solid rgba(42, 84, 209, 0.2);

    &::after {
      content: "";
      position: absolute;
      width: 100%;
      bottom: 100%;
      left: 0;
      height: 35px;
    }

    .cascader-menu-wrap {
      display: flex;
    }

    .cascader-menu {
      border-right: 1px dashed #d8d8d8;
      border-radius: 0 4px 4px 0;
      width: 180px;
      padding-top: 10px;
      color: #666666;

      .cascader-title {
        padding: 0 25px;
        height: 34px;
        line-height: 34px;
        font-weight: bold;
        color: #1a1a1a;
      }

      .cascader-menu__list {
        height: 247px;
        overflow-x: hidden;
        overflow-y: auto;

        .cascader-node {
          padding: 0 25px;
          height: 34px;
          line-height: 34px;
          cursor: default;

          &.in-active-path {
            color: #2a54d1;
          }

          &:not(.is-disabled):hover,
          &:not(.is-disabled):focus {
            color: #2a54d1;
          }
        }
      }

      &:last-child {
        border-right: none;

        .cascader-menu__list {
          .cascader-node {
            cursor: pointer;
          }
        }
      }

      &:nth-child(3) {
        color: #2e3234;
      }
    }
  }
}
</style>
